export const DOCUMENT_TYPES=[

    {
        value:"aadhaar_front",
        label:"Aadhaar Front"
    },

    {
        value:"aadhaar_back",
        label:"Aadhaar Back"
    },

    {
        value:"pan",
        label:"PAN Card"
    },

    {
        value:"salary_slip",
        label:"Salary Slip"
    },

    {
        value:"bank_statement",
        label:"Bank Statement"
    },

    {
        value:"itr",
        label:"ITR"
    }

];